import { useNavigate } from '@tanstack/react-router';
import { getHelpdeskUrl } from '../lib/helpdesk-utils';

/**
 * Hook that provides navigation functions for unified helpdesk routes
 * No longer requires org slug - all routes are under /helpdesk/*
 */
export const useHelpdeskNavigation = () => {
  const navigate = useNavigate();

  const navigateTo = {
    dashboard: () => navigate({ to: getHelpdeskUrl.dashboard() }),
    tickets: () => navigate({ to: getHelpdeskUrl.tickets() }),
    ticket: (id: string) => navigate({ to: getHelpdeskUrl.ticket(id) }),
    newTicket: () => navigate({ to: getHelpdeskUrl.newTicket() }),
    customers: () => navigate({ to: getHelpdeskUrl.customers() }),
    customer: (id: string) => navigate({ to: getHelpdeskUrl.customer(id) }),
    newCustomer: () => navigate({ to: getHelpdeskUrl.newCustomer() }),
    knowledgeBase: () => navigate({ to: getHelpdeskUrl.knowledgeBase() }),
    article: (id: string) => navigate({ to: getHelpdeskUrl.article(id) }),
    newArticle: () => navigate({ to: getHelpdeskUrl.newArticle() }),
    settings: () => navigate({ to: getHelpdeskUrl.settings() }),
    orgSettings: () => navigate({ to: '/helpdesk/org-settings' }),
  };

  const getPath = {
    dashboard: () => getHelpdeskUrl.dashboard(),
    tickets: () => getHelpdeskUrl.tickets(),
    ticket: (id: string) => getHelpdeskUrl.ticket(id),
    newTicket: () => getHelpdeskUrl.newTicket(),
    customers: () => getHelpdeskUrl.customers(),
    customer: (id: string) => getHelpdeskUrl.customer(id),
    newCustomer: () => getHelpdeskUrl.newCustomer(),
    knowledgeBase: () => getHelpdeskUrl.knowledgeBase(),
    article: (id: string) => getHelpdeskUrl.article(id),
    newArticle: () => getHelpdeskUrl.newArticle(),
    settings: () => getHelpdeskUrl.settings(),
    orgSettings: () => '/helpdesk/org-settings',
  };

  return {
    navigateTo,
    getPath,
  };
};
